// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5161":"58dc6eaa","7340":"11b5ff33"}[chunkId] + ".chunk.css";
};